import { Metadata } from 'next';
import OGImage from '../../public/ReserveMyLoanOG.webp';

export const defaultMetadata: Metadata = {
  metadataBase: new URL('https://reserve-my-loan-dev.staging.halo-lab.team/'),
  title: 'Reserve My Loan',
  description:
    'Reserve My Loan is a premier provider of consumer financial services.',
  openGraph: { images: [OGImage.src] },
};
